<template>
  <form>
    <fieldset :id="name">
      <t-radio
        v-for="option in formattedOptions"
        :key="`${name}-radio-${option[key]}`"
        :class="[extraClasses]"
        :id="`radio-${option[key]}`"
        :name="name"
        :value="option[key]"
        class="cursor-pointer w-full"
        wrapped
        v-model="selected"
      >
        <template v-if="$slots.label || $scopedSlots.label">
          <slot name="label" v-bind="option" />
        </template>
        <span v-else>
          {{ option[label] }}
        </span>
      </t-radio>
    </fieldset>
  </form>
</template>

<script>
import WRadioGroup from './WRadioGroup';

export default WRadioGroup;
</script>

<style lang="scss" scoped>
@import 'WRadioGroup';
</style>
